// extracted by mini-css-extract-plugin
export default {"products":"Ey-z","card":"Fy-z","oosMessaging":"Gy-z"};